import { render } from "./QuestionModeration.vue?vue&type=template&id=16f28db8"
import script from "./QuestionModeration.vue?vue&type=script&lang=js"
export * from "./QuestionModeration.vue?vue&type=script&lang=js"

import "./QuestionModeration.vue?vue&type=style&index=0&id=16f28db8&lang=scss"

import exportComponent from "/home/runner/work/stpancras-backstage-app/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__